export const ColumnIds = {
  name: 'name',
  displayOrder: 'displayOrder',
  code: 'code'
} as const;